<template>
    <ui5-dialog
        ref="dialog"
        :header-text="trans('pages.recurring.delete_blocked_title')"
        class="recurring-delete-warning-dialog"
    >
        <div class="dialog-content">
            <p class="warning-message">{{ trans('pages.recurring.delete_blocked_message') }}</p>

            <div class="trips-with-orders">
                <p class="trips-label">{{ trans('pages.recurring.delete_blocked_trips_label') }}</p>
                <ul class="trips-list">
                    <li
                        v-for="trip in trips"
                        :key="trip.id"
                        class="trip-item"
                    >
                        {{ trans('pages.recurring.delete_blocked_trip_info', { date: formatDate(trip.date), count: trip.orderCount }) }}
                    </li>
                </ul>
            </div>

            <ui5-message-strip
                design="Warning"
                class="info-strip"
            >
                {{ trans('pages.recurring.delete_blocked_instructions') }}
            </ui5-message-strip>
        </div>

        <div
            slot="footer"
            class="dialog-footer"
        >
            <ui5-button @click="close">
                {{ trans('pages.recurring.delete_blocked_ok') }}
            </ui5-button>
        </div>
    </ui5-dialog>
</template>

<script>
import localization from '../../mixins/localization';

export default {
    mixins: [localization],
    data() {
        return {
            trips: []
        };
    },
    methods:  {
        /**
         * Open the dialog with trip details
         * @param {Array} trips - Array of trip objects with {id, date, orderCount}
         */
        open(trips) {
            this.trips = trips || [];
            this.$refs.dialog.show();
        },

        close() {
            this.$refs.dialog.close();
            this.trips = [];
        },

        formatDate(dateString) {
            // Format date as DD/MM/YYYY
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        }
    }
};
</script>

<style scoped>
.recurring-delete-warning-dialog .dialog-content {
    padding: 1rem;
    max-width: 500px;
}

.warning-message {
    margin-bottom: 1.5rem;
    font-weight: 500;
}

.trips-with-orders {
    margin-bottom: 1.5rem;
}

.trips-label {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.trips-list {
    list-style-type: none;
    padding-left: 1rem;
    margin: 0.5rem 0;
}

.trip-item {
    padding: 0.25rem 0;
    color: #d32f2f;
}

.trip-item::before {
    content: '• ';
    font-weight: bold;
}

.info-strip {
    margin-top: 1.5rem;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    padding: 0.5rem;
}
</style>
